import { type CalculatorEnv, CALCULATOR_ENV_VALUES } from "../state";

export function isValidHttpUrl(potentialUrl: string) {
  let url;

  try {
    url = new URL(potentialUrl);
  } catch {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}

export function removeTrailingSlash(str: string) {
  return str.replace(/\/$/, "");
}

export function removeFileExtension(str: string) {
  return str.replace(/\/([^/]+)\.(\w+)$/, "/$1");
}

export function getCalculatorEnvFromUrl(url: string): CalculatorEnv | null {
  let parsed: URL;

  try {
    parsed = new URL(url);
  } catch {
    return null;
  }

  const env = parsed.searchParams.get("env");
  if (env && CALCULATOR_ENV_VALUES.includes(env as CalculatorEnv)) {
    return env as CalculatorEnv;
  }

  return null;
}

export function getSlugAndAccesscodeFromUrl(url: string): { slug: string; accesscode: string } | null {
  let parsed: URL;

  try {
    parsed = new URL(url);
  } catch {
    return null;
  }

  if (parsed.searchParams.has("slug") && parsed.searchParams.has("accesscode")) {
    return {
      slug: parsed.searchParams.get("slug") ?? "",
      accesscode: parsed.searchParams.get("accesscode") ?? "",
    };
  }

  let pathname = removeTrailingSlash(parsed.pathname);
  pathname = removeFileExtension(pathname);

  const segments = pathname.split("/").filter(Boolean);

  if (segments.length < 2) {
    return null;
  }

  return {
    slug: segments[0],
    accesscode: segments[segments.length - 1],
  };
}
